import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=4fb9fd2c&"
import script from "./BaseLink.vue?vue&type=script&lang=js&"
export * from "./BaseLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports